// Convert selects to select2 elements
jQuery(document).ready(function($) {
    if($('.category-dropdown #cat').length){
        $('.category-dropdown #cat').select2({
            minimumResultsForSearch: Infinity,
            dropdownParent: $('.category-dropdown')
        });
    }
    if($('.category-dropdown #event-cat').length){
        $('.category-dropdown #event-cat').select2({
            minimumResultsForSearch: Infinity,
            dropdownParent: $('.category-dropdown')
        });
    }
    if($('.daterange-dropdown #daterange').length){
        $('.daterange-dropdown #daterange').select2({
            minimumResultsForSearch: Infinity,
            dropdownParent: $('.daterange-dropdown')
        });
    }

    if($('#shipping_address_book_field #shipping_address_book').length){
        $('#shipping_address_book_field #shipping_address_book').select2({
            minimumResultsForSearch: Infinity,

        });
    }
});


